module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1AAHI6b/media/FC-9781398489622.jpg?1697494195226",
      "alt": "This image is the cover for the book Hush"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hush\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In the gripping novel titled Hush, the protagonist grapples with the weight of her mistakes, realizing that even the smallest misstep can have far-reaching consequences. For her, it’s not just a mere error; it has a name—a crime that threatens to cast a lifelong shadow, and worst of all, it means letting down the people she holds dear. Like a precarious row of dominoes, her entire life’s work teeters on the edge, vulnerable to the slightest nudge. The haunting fear of being unloved and becoming a source of disgrace forces her to abandon logic, plunging her into the clutches of a mysterious man who offers a dubious solution. Unaware of the profound upheaval this decision will unleash upon her existence, she embraces the man’s proposition in a desperate bid to salvage her future. Little does she know that her choice will upend her life, hurling her heart into the heart of a cyclone fuelled by tumultuous emotions.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Liz Sorora\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Liz Sorora was born in a small city of Albania and was raised in a village in Greece. Liz has grown to be an education major, with psychological interests, as well as a huge passion for literature, arts and philosophy. If she isn’t spending her time writing, then you most likely will find her painting and listening to music. Creating for her is a means to reach out to someone, comfort them, embrace them and entertain them. She is a firm believer that there’re many ways individuals can learn and thus she tries to embody in her writings life lessons.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0